export const contactHeaders = {
  contactAddress: {
    title: '連絡先',
    create: {
      text: '連絡先を追加',
      targetUrl: '/contactAddress/createContact',
      baseUrl: '/contactAddress',
    },
    import: {
      text: '連絡先をインポート（CSV形式）',
      targetUrl: '/contactAddress/ImportFile',
      baseUrl: '/contactAddress',
    },
  },
  contactGroup: {
    title: 'グループ',
    create: {
      text: 'グループを作成',
      targetUrl: '/contactGroup/createGroup',
      baseUrl: '/contactGroup',
    },
    import: undefined,
  },
  mgrUser: {
    title: 'ユーザー管理',
    create: {
      text: 'ユーザーを作成',
      targetUrl: '/manageUser/createUser',
      baseUrl: '/manageUser',
    },
    import: undefined,
  },
}
